// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"282":"607e7d1a","397":"349ac0bc","488":"d5252bcc"}[chunkId] + ".chunk.js";
};